import React, { useState, useEffect, useRef } from "react";
import "./carosel-Style.css"; // mantém seu CSS original

const Carousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const startX = useRef(null);
  const isDragging = useRef(false);

  // Troca automática das imagens a cada 3 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  // ====== TOUCH (mobile) ======
  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
    isDragging.current = true;
  };

  const handleTouchMove = (e) => {
    if (!isDragging.current) return;
    const currentX = e.touches[0].clientX;
    const diff = startX.current - currentX;

    if (diff > 50) {
      nextSlide();
      isDragging.current = false;
    } else if (diff < -50) {
      prevSlide();
      isDragging.current = false;
    }
  };

  const handleTouchEnd = () => {
    isDragging.current = false;
  };

  // ====== MOUSE (desktop) ======
  const handleMouseDown = (e) => {
    startX.current = e.clientX;
    isDragging.current = true;
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    const currentX = e.clientX;
    const diff = startX.current - currentX;

    if (diff > 50) {
      nextSlide();
      isDragging.current = false;
    } else if (diff < -50) {
      prevSlide();
      isDragging.current = false;
    }
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  const handleMouseLeave = () => {
    isDragging.current = false;
  };

  // Define a classe de cada imagem (mantém o estilo original)
  const getClassName = (index) => {
    const diff = (index - currentIndex + images.length) % images.length;
    switch (diff) {
      case 0:
        return "selected";
      case 1:
        return "next";
      case 2:
        return "nextRightSecond";
      case images.length - 1:
        return "prev";
      case images.length - 2:
        return "prevLeftSecond";
      default:
        return diff < images.length / 2 ? "hideRight" : "hideLeft";
    }
  };

  return (
    <main>

      <div
        id="carousel"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
        style={{ cursor: "grab" }} // feedback visual
      >
        {images.map((img, index) => (
          <div key={index} className={getClassName(index)}>
            <img src={img} alt={`carousel-${index}`} draggable="false" />
          </div>
        ))}
      </div>
    </main>
  );
};

export default Carousel;
